import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconKeyboard1"><Path d="M8.75 13V21M15.25 13V21M7.25 3.75V12.75H10.25V3.75H7.25ZM13.75 3.75V12.75H16.75V3.75H13.75ZM6.75 21.25H17.25C18.9069 21.25 20.25 19.9069 20.25 18.25V6.75C20.25 5.09315 18.9069 3.75 17.25 3.75H6.75C5.09315 3.75 3.75 5.09315 3.75 6.75V18.25C3.75 19.9069 5.09315 21.25 6.75 21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconKeyboard1;
